import { v1 as uuid } from 'uuid';

export enum JobStatus {
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  INVALID_FILE_NAME = 'INVALID_FILE_NAME',
  ENQUEUED = 'ENQUEUED',
  UPLOAD_INPROGRESS = 'UPLOAD_INPROGRESS',
  UPLOAD_FAILURE = 'UPLOAD_FAILURE',
  BIND_INPROGRESS = 'BIND_INPROGRESS',
  BIND_FAILURE = 'BIND_FAILURE',
  FINISH = 'FINISH',
}

export type Job = {
  uuid: string;
  fileName: string;
  fileSize: number;
  fileLastModified: number;
  parent_node_id: number;
  status: JobStatus;
  uploadProgress: number | null;
  uploadSpeed: number | null;
  remainingTime: number | null;
  ellapsedTime: number | null;
  errorMessage: string | null;
  createdNodeId: number | null;
};

export const makeKey = (j: Job): string =>
  [j.fileName, j.fileSize, j.fileLastModified, j.parent_node_id].join('#');

export const makeJob = (file: File, parent_node_id: number): Job => ({
  uuid: uuid(),
  fileName: file.name,
  fileSize: file.size,
  fileLastModified: file.lastModified,
  parent_node_id,
  status: JobStatus.PENDING_VALIDATION,
  uploadProgress: null,
  uploadSpeed: null,
  remainingTime: null,
  ellapsedTime: null,
  errorMessage: null,
  createdNodeId: null,
});

export type UploaderShape = {
  jobs: Job[];
  modalOpen: boolean;
  pendingUpload: boolean;
  // true when an upload batch finishes while the modal is closed — drives the
  // "Complete" button state and the completion toast.
  completedInBackground: boolean;
};

export const initialState: UploaderShape = {
  jobs: [],
  modalOpen: false,
  pendingUpload: false,
  completedInBackground: false,
};

const FAILED_STATUSES = [
  JobStatus.UPLOAD_FAILURE,
  JobStatus.BIND_FAILURE,
  JobStatus.INVALID_FILE_NAME,
];
const SETTLED_STATUSES = [...FAILED_STATUSES, JobStatus.FINISH];

export const jobIsFailed = (j: Job): boolean => FAILED_STATUSES.includes(j.status);
export const jobIsSettled = (j: Job): boolean => SETTLED_STATUSES.includes(j.status);
export const jobIsSuccessful = (j: Job): boolean => j.status === JobStatus.FINISH;

export const getJobUploadProgress = (j: Job): number => {
  switch (j.status) {
    case JobStatus.FINISH:
      return 1;
    case JobStatus.BIND_INPROGRESS:
      return 0.99;
    case JobStatus.UPLOAD_INPROGRESS:
      return (j.uploadProgress ?? 0) * 0.99;
    default:
      return 0;
  }
};
